import { useSvgParsedStyle } from '@/_shared/hooks/useSvgParsedStyle';
import { SvgProps } from '@/_shared/types/svg';

export const EyeOff = ({ style }: SvgProps) => {
  const { primaryColorToUse, heightToUse, widthToUse } = useSvgParsedStyle({
    defaultWidth: '25',
    defaultHeight: '25',
    strokeAsPrimary: true,
    style,
  });

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={widthToUse}
      height={heightToUse}
      fill='none'
      viewBox='0 0 25 25'
    >
      <path
        stroke={primaryColorToUse}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
        d='M10.8697 10.2519C10.575 10.5266 10.3386 10.8578 10.1746 11.2258C10.0107 11.5938 9.92249 11.991 9.91538 12.3939C9.90827 12.7967 9.98237 13.1968 10.1333 13.5703C10.2841 13.9439 10.5087 14.2832 10.7936 14.5681C11.0785 14.853 11.4178 15.0776 11.7914 15.2284C12.1649 15.3793 12.565 15.4534 12.9678 15.4463C13.3706 15.4392 13.7679 15.351 14.1359 15.1871C14.5039 15.0231 14.8351 14.7867 15.1097 14.4919M11.7197 5.45195C12.1411 5.39946 12.5652 5.37274 12.9897 5.37195C19.9897 5.37195 22.9897 12.3719 22.9897 12.3719C22.5427 13.3291 21.982 14.2289 21.3197 15.0519M7.59975 6.98195C5.611 8.33657 4.01962 10.1972 2.98975 12.3719C2.98975 12.3719 5.98975 19.3719 12.9897 19.3719C14.9057 19.3771 16.7805 18.8171 18.3797 17.7619M2.98975 2.37195L22.9897 22.3719'
      />
    </svg>
  );
};
